export const fromPairs = <K extends number | string, V>(
    pairs: [K, V][],
): Record<K, V> => {
    return pairs.reduce(
        (acc, [key, value]) => {
            acc[key] = value
            return acc
        },
        {} as Record<K, V>,
    )
}

export function fromPairsMulti<K extends string | number, V>(
    pairs: [K, V][],
): Record<K, V[]> {
    return pairs.reduce(
        (acc, [key, value]) => {
            if (!acc[key]) acc[key] = []
            acc[key].push(value)
            return acc
        },
        {} as Record<K, V[]>,
    )
}
